import { axios, Response } from '../index'

export interface Body {
  avatar?: string
  avatarName?: string
  firstName: string
  lastName: string
  gender: string
  cpfOrPassport: string
  email?: string
  zipCode?: string
  address?: string
  houseNumber?: string
  city?: string
  state?: string
  complement?: string
  countryCode?: string
  ddd?: string
  telephoneNumber?: string
  birthday: string
}

const updatePatient = (patientId: string, body: Body): Response<null> => {
  return axios.put('/v1/patients/' + patientId, body)
}

export default updatePatient
